import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { CheckoutDocuments } from "src/app/models/enrollment-checkout";
import { ResourceLink } from "src/app/models/resource-link";
import { TableColumn } from "src/app/models/table";
import { HelperService } from "src/app/services/helper.service";
import { TableService } from "src/app/services/table.service";
import { TextType } from 'src/app/constants/text-type';
import { FormValidationService } from "src/app/services/form-validation.service";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-documents',
    templateUrl: './documents.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutDocumentsComponent implements OnInit {
    @Input() public checkoutDocuments: CheckoutDocuments;

    public accept = false;

    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public columnType = TableColumnType;
    public renderdColumns: string[] = [];
    public checkboxName: string = 'isChecked';
    public linkUrlName: string = 'linkUrl';
    public documentFormArrayName: string = 'documentFormArray';
    public resourceForm: FormGroup;
    public tableData: MatTableDataSource<ResourceLink> = new MatTableDataSource<ResourceLink>();
    public tableColumns: TableColumn[] = [
        {
            columnName: 'Required',
            propertyId: this.checkboxName,
            columnType: TableColumnType.checkBox,
            width: '10%'
        },
        {
            columnName: 'Resource',
            propertyId: 'linkUrl',
            columnType: TableColumnType.hyperLink,
            dataTypePropertyId: 'linkText',
        },
    ];

    constructor(
        private formBuilder: FormBuilder,
        private helperService: HelperService,
        private tableService: TableService,
    ) {
    }

    ngOnInit(): void {
        this.renderdColumns = this.tableService.extractTableColumnNames(this.tableColumns);
        const l_Resources: ResourceLink[] = this.helperService.generateResourceIcons(this.checkoutDocuments.documents);

        let l_FormArray: FormArray = new FormArray([], FormValidationService.formArrayRequiresCheckboxChecked(this.checkboxName, l_Resources.length));
        l_Resources.forEach((resource: ResourceLink) => {
            l_FormArray.push(
                this.formBuilder.group({
                    linkText: [resource.linkText],
                    // [this.checkboxName]: [{ value: null, disabled: true }, Validators.required],
                    [this.checkboxName]: [{ value: false, disabled: true }],
                    [this.linkUrlName]: [resource.linkUrl],
                })
            );
        });

        this.resourceForm = this.formBuilder.group({ 
                [this.documentFormArrayName]: l_FormArray
        });

        this.tableData.data = l_Resources;
    }

    // HACK - This automatically updates a header column name when changed
    // How does this work, Only god knows now
    trackByIndex(i: any): any {
        return i;
    }

    public displayElement(tableColumn: TableColumn, type: TableColumnType, element: any): boolean {
        return this.tableService.displayElement(tableColumn, type, element);
    }

    public findElementByColumnName(element: any, column: string, textType: TextType): string {
        return this.tableService.findElementByColumnName(element, column, textType);
    }

    public openLink(url: string): void {
        window.open(url, "_blank");

        const l_FormArray = this.resourceForm.get(this.documentFormArrayName) as FormArray;
        l_FormArray.controls.map((cfa) => {
            if (cfa.get(this.linkUrlName).value == url) {                
                cfa.get(this.checkboxName).setValue(true);
                cfa.updateValueAndValidity();
            }
        });
        this.resourceForm.updateValueAndValidity();
    }

    public complete(): void {
        this.emitComplete.emit();
    }
}